import React from 'react';

import styled from 'styled-components';

import { LoadingIndicator } from 'react95';

const Wrapper = styled.div`
  background: #C6C6C6;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const Load = () => (
  <Wrapper>
    <div style={{width: '80%', margin: '10px'}}>
      <p style={{ textAlign: 'center', marginBottom: '0.5rem' }}>Loading...</p>
      <LoadingIndicator isLoading />
    </div>
  </Wrapper>
);

Load.story = {
  name: 'default'
};